// extracted by mini-css-extract-plugin
export default {"profileHeader":"styles_profileHeader__Y4WjB","back":"styles_back__CGVau","text":"styles_text__Fz8XO"};